module.exports = __webpack_public_path__ + "static/Frogsong6-dcbafc55107d4f85300f8e58deed9efb.png";